<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          新建客户（服务商企业专用）
        </h1>
        <p class="text-gray-600">
          创建一个新的企业客户，获取客户唯一标识。这个接口是服务商企业用来新建自己的客户用。自用企业不用对接
        </p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                创建客户接口用于在银企通™
                API平台创建一个新的企业客户，并返回唯一的客户编码。
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-green-100 text-green-800 text-sm font-medium rounded-full"
                  >POST</span
                >
                <code class="text-sm font-mono">/api/v2/customer/create</code>
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            应用ID
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            认证信息
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            Content-Type
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            发送内容类型
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            application/json
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            customerName
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            客户名称
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            银企通™ API测试客户02
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回状态 200成功
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.customerCode
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            客户码
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            message
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            失败时返回错误信息
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            realJsonModel
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回json，true
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            status
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            http状态码
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            successResponse
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Boolean
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            成功返回
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求示例
                  </h3>
                  <div class="border rounded-lg overflow-hidden">
                    <div
                      class="bg-gray-800 text-gray-200 px-4 py-2 text-sm font-medium"
                    >
                      cURL
                    </div>
                    <pre
                      class="p-4 bg-gray-900 text-gray-100 text-sm overflow-x-auto"
                    ><code>curl -X POST '{{sandboxUrl}}/api/v2/customer/create' \
    -H 'x-app-id: 4d9414e89bc24b0d89b678d9f20bc56a' \
    -H 'x-app-secret: 8201e508ef948b8fcdca855729e7ee34' \
    -H 'Content-Type: application/json' \
    -d '{"customerName":"银企通™ API测试客户02"}'</code></pre>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应示例
                  </h3>
                  <div class="border rounded-lg overflow-hidden">
                    <div
                      class="bg-gray-800 text-gray-200 px-4 py-2 text-sm font-medium"
                    >
                      JSON
                    </div>
                    <pre
                      class="p-4 bg-gray-900 text-gray-100 text-sm overflow-x-auto"
                    ><code>{{ successResponseExample }}</code></pre>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧内容 -->
        <div class="w-full lg:col-span-2">
          <Card class="sticky top-8">
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription> 在线测试创建客户接口 </CardDescription>
            </CardHeader>
            <CardContent>
              <div class="space-y-4">
                <!-- 语言切换标签 -->
                <div class="border-b border-gray-200">
                  <nav class="-mb-px flex space-x-8 overflow-x-auto">
                    <button
                      v-for="language in languages"
                      :key="language.id"
                      @click="activeLanguage = language.id"
                      class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                      :class="[
                        activeLanguage === language.id
                          ? 'border-[var(--primary)] text-[var(--primary)]'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                      ]"
                    >
                      {{ language.name }}
                    </button>
                  </nav>
                </div>

                <!-- 请求文本 -->
                <div>
                  <pre
                    class="hljs bg-gray-900 text-gray-100 p-4 rounded-lg text-sm overflow-x-auto border border-gray-700"
                  ><code>{{ getRequestText() }}</code></pre>
                </div>

                <!-- 语言特定的输入界面 -->
                <div v-if="activeLanguage === 'curl'">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder="请输入应用ID"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder="请输入认证信息"
                    />
                  </div>
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >customerName</label
                    >
                    <input
                      v-model="customerName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder="请输入客户名称"
                    />
                  </div>
                  <button
                    @click="createCustomer"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style="background-color: var(--primary)"
                  >
                    {{ loading ? "创建中..." : "创建客户" }}
                  </button>
                </div>

                <div v-else-if="activeLanguage === 'javascript'">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >客户名称</label
                    >
                    <input
                      v-model="customerName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入客户名称"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入应用ID"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入认证信息"
                    />
                  </div>

                  <button
                    @click="createCustomerJS"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style="background-color: var(--primary)"
                  >
                    {{ loading ? "创建中..." : "创建客户" }}
                  </button>
                </div>

                <div v-else-if="activeLanguage === 'python'">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >客户名称</label
                    >
                    <input
                      v-model="customerName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入客户名称"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入应用ID"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入认证信息"
                    />
                  </div>

                  <button
                    @click="createCustomerPython"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style="background-color: var(--primary)"
                  >
                    {{ loading ? "创建中..." : "创建客户" }}
                  </button>
                </div>

                <div v-else-if="activeLanguage === 'java'">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >客户名称</label
                    >
                    <input
                      v-model="customerName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入客户名称"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入应用ID"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]]"
                      placeholder="请输入认证信息"
                    />
                  </div>

                  <button
                    @click="createCustomerJava"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style="background-color: var(--primary)"
                  >
                    {{ loading ? "创建中..." : "创建客户" }}
                  </button>
                </div>

                <div v-else-if="activeLanguage === 'csharp'">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >客户名称</label
                    >
                    <input
                      v-model="customerName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入客户名称"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入应用ID"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入认证信息"
                    />
                  </div>

                  <button
                    @click="createCustomerCSharp"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style="background-color: var(--primary)"
                  >
                    {{ loading ? "创建中..." : "创建客户" }}
                  </button>
                </div>

                <div v-else-if="activeLanguage === 'php'">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >客户名称</label
                    >
                    <input
                      v-model="customerName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入客户名称"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入应用ID"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入认证信息"
                    />
                  </div>

                  <button
                    @click="createCustomerPHP"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style="background-color: var(--primary)"
                  >
                    {{ loading ? "创建中..." : "创建客户" }}
                  </button>
                </div>

                <div v-else-if="activeLanguage === 'ruby'">
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >客户名称</label
                    >
                    <input
                      v-model="customerName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入客户名称"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入APP ID"
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="请输入API Key"
                    />
                  </div>

                  <button
                    @click="createCustomerRuby"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style="background-color: var(--primary)"
                  >
                    {{ loading ? "创建中..." : "创建客户" }}
                  </button>
                </div>

                <!-- 响应结果 -->
                <div v-if="response">
                  <h4 class="font-medium text-gray-900 mb-2">响应结果</h4>
                  <pre
                    class="text-sm bg-gray-100 p-3 rounded border overflow-x-auto max-h-40"
                  ><code>{{ response }}</code></pre>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Sidebar from "./Sidebar.vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import hljs from "highlight.js/lib/core";
import httpService from "@/lib/http";
import { useSystemStore } from "@/stores/system";
// 使用代码高亮
const highlightCode = () => {
  nextTick(() => {
    // 等待DOM更新完成后再处理
    setTimeout(() => {
      // 找到所有代码块
      const allCodeBlocks = document.querySelectorAll("pre code");

      // 语言映射表
      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };

      const langClass = languageMap[activeLanguage.value];

      // 处理所有代码块
      allCodeBlocks.forEach((block) => {
        // 清除之前的高亮
        block.className = "";
        block.removeAttribute("data-highlighted");

        // 重新添加基础类和语言类
        block.classList.add("hljs");
        if (langClass) {
          block.classList.add(langClass);
        }

        try {
          hljs.highlightElement(block as HTMLElement);
        } catch (error) {
          console.warn("代码高亮失败:", error);
        }
      });
    }, 100); // 减少延迟时间
  });
};

// 初始化代码高亮
highlightCode();

// 系统配置
const systemStore = useSystemStore();
const sandboxUrl = import.meta.env.VITE_API_URL;
const serverUrl = import.meta.env.VITE_API_URL;

// 默认值
const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";

const customerName = ref("银企通™ API测试客户02");
const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const loading = ref(false);
const response = ref("");
const activeLanguage = ref("curl");

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");

    if (response) {
      return {
        appId: response.appId,
        appSecret: response.appSecret,
      };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};
// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");

  if (userInfoStr) {
    // 获取应用信息
    const appInfo = await getApplicationInfo();

    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
    }
  }
};
// 组件挂载时登录后自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});
// 监听响应式变量变化，重新应用代码高亮
watch(
  [appId, authorization, activeLanguage, response],
  () => {
    highlightCode();
  },
  { flush: "post" }
);
// 语言选项
const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

// 成功响应示例
const successResponseExample = `{
  "code": "200",
  "data": {
    "customerCode": "CUSTFA48DD8EFF437956"
  },
  "message": "",
  "realJsonModel": "true",
  "status": "200",
  "successResponse": true
}`;

// 获取请求文本
const getRequestText = () => {
  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X POST '${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/create' \n` +
        `  -H 'x-app-id: ${appId.value}' \n` +
        `  -H 'x-app-secret: ${authorization.value}' \n` +
        `  -H 'Content-Type: application/json' \n` +
        `  -d '{\"customerName\":\"${customerName.value}\"}'`
      );

    case "javascript":
      return (
        `const axios = require('axios');\n\n` +
        `const data = {\n` +
        `  'customerName': '${customerName.value}'\n` +
        `};\n\n` +
        `const config = {\n` +
        `  method: 'post',\n` +
        `  url: '${import.meta.env.VITE_API_URL}/api/v2/customer/create',\n` +
        `  headers: { \n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'Content-Type': 'application/json'\n` +
        `  },\n` +
        `  data: JSON.stringify(data)\n` +
        `};\n\n` +
        `axios(config)\n` +
        `  .then(function (response) {\n` +
        `    console.log(JSON.stringify(response.data));\n` +
        `  })\n` +
        `  .catch(function (error) {\n` +
        `    console.log(error);\n` +
        `  });`
      );

    case "python":
      return (
        `import requests\n` +
        `import json\n\n` +
        `url = "${import.meta.env.VITE_API_URL}/api/v2/customer/create"\n\n` +
        `payload = json.dumps({'customerName': '${customerName.value}'})\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'Content-Type': 'application/json'\n` +
        `}\n\n` +
        `response = requests.request("POST", url, headers=headers, data=payload)\n\n` +
        `print(response.text)`
      );

    case "java":
      return (
        `OkHttpClient client = new OkHttpClient().newBuilder()\n` +
        `  .build();\n` +
        `MediaType mediaType = MediaType.parse("application/json");\n` +
        `RequestBody body = RequestBody.create(mediaType, "{\\\"customerName\\\":\\\"${customerName.value}\\\"}");\n` +
        `Request request = new Request.Builder()\n` +
        `  .url("${import.meta.env.VITE_API_URL}/api/v2/customer/create")\n` +
        `  .method("POST", body)\n` +
        `  .addHeader("x-app-id", "${appId.value}")\n` +
        `  .addHeader("x-app-secret", "${authorization.value}")\n` +
        `  .addHeader("Content-Type", "application/json")\n` +
        `  .build();\n` +
        `Response response = client.newCall(request).execute();`
      );

    case "csharp":
      return (
        `var client = new RestClient("${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/create");\n` +
        `var request = new RestRequest(Method.POST);\n` +
        `request.AddHeader("x-app-id", "${appId.value}");\n` +
        `request.AddHeader("x-app-secret", "${authorization.value}");\n` +
        `request.AddHeader("Content-Type", "application/json");\n` +
        `request.AddParameter("application/json", "{\\\"customerName\\\":\\\"${customerName.value}\\\"}", ParameterType.RequestBody);\n` +
        `IRestResponse response = client.Execute(request);\n` +
        `Console.WriteLine(response.Content);`
      );

    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, array(\n` +
        `  CURLOPT_URL => '${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/create',\n` +
        `  CURLOPT_RETURNTRANSFER => true,\n` +
        `  CURLOPT_ENCODING => '',\n` +
        `  CURLOPT_MAXREDIRS => 10,\n` +
        `  CURLOPT_TIMEOUT => 0,\n` +
        `  CURLOPT_FOLLOWLOCATION => true,\n` +
        `  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,\n` +
        `  CURLOPT_CUSTOMREQUEST => 'POST',\n` +
        `  CURLOPT_POSTFIELDS => '{\"customerName\":\"${customerName.value}\"}',\n` +
        `  CURLOPT_HTTPHEADER => array(\n` +
        `    'x-app-id: ${appId.value}',\n` +
        `    'x-app-secret: ${authorization.value}',\n` +
        `    'Content-Type: application/json'\n` +
        `  ),\n` +
        `));\n\n` +
        `$response = curl_exec($curl);\n\n` +
        `curl_close($curl);\n` +
        `echo $response;`
      );

    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n\n` +
        `url = URI("${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/create")\n\n` +
        `https = Net::HTTP.new(url.host, url.port);\n` +
        `https.use_ssl = true\n\n` +
        `request = Net::HTTP::Post.new(url)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["Content-Type"] = "application/json"\n` +
        `request.body = "{\\\"customerName\\\":\\\"${customerName.value}\\\"}"\n\n` +
        `response = https.request(request)\n` +
        `puts response.read_body`
      );

    default:
      return "";
  }
};

// cURL方式创建客户
const createCustomer = async () => {
  if (!customerName.value || !appId.value || !authorization.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch(`${serverUrl}/api/v2/customer/create`, {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerName: customerName.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// JavaScript方式创建客户
const createCustomerJS = async () => {
  if (!customerName.value || !appId.value || !authorization.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const data = {
      customerName: customerName.value,
    };

    const config = {
      method: "POST",
      url: "/api/v2/customer/create",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    const res = await fetch(config.url, {
      method: config.method,
      headers: config.headers,
      body: config.body,
    });

    const responseData = await res.json();
    response.value = JSON.stringify(responseData, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Python方式创建客户 (模拟)
const createCustomerPython = async () => {
  if (!customerName.value || !appId.value || !authorization.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/create", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerName: customerName.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Java方式创建客户
const createCustomerJava = async () => {
  if (!customerName.value || !appId.value || !authorization.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/create", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerName: customerName.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// C#方式创建客户
const createCustomerCSharp = async () => {
  if (!customerName.value || !appId.value || !authorization.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/create", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerName: customerName.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// PHP方式创建客户
const createCustomerPHP = async () => {
  if (!customerName.value || !appId.value || !authorization.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/create", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerName: customerName.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Ruby方式创建客户
const createCustomerRuby = async () => {
  if (!customerName.value || !appId.value || !authorization.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/create", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerName: customerName.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
/* 添加任何需要的自定义样式 */
</style>
